import { css } from '@emotion/css';
import React, { useEffect, useRef } from 'react';
import { Editor, Range } from 'slate';
import { useFocused } from 'slate-react';
import { MarkButton } from './markButton';
import { Portal } from 'shared/chat/component';
import { ToolbarMenu } from 'packages/richText/menu';
// import { BlockButton } from './blockButton';


const HoveringToolbar = ({ editor, className, disabled}) => {
  const ref = useRef();
  const inFocus = useFocused();

  useEffect(() => {
  
    const el = ref.current;
    if (!el) {
      return;
    }
    if (
      !editor.selection ||
      !inFocus ||
      Range.isCollapsed(editor.selection) ||
      Editor.string(editor, editor.selection) === ''
    ) {
      el.removeAttribute('style');
      return;
    }
    const domSelection = window.getSelection();

    if (!domSelection || domSelection.rangeCount === 0) {
      el.style.opacity = "0";
      el.style.top = "-10000px";
      el.style.left = "-10000px";
      return;
    }
    
    const domRange = domSelection.getRangeAt(0);
    const rect = domRange.getBoundingClientRect();
    el.style.opacity = '1';
    el.style.top = `${rect.top + window.pageYOffset - el.offsetHeight}px`;
    el.style.left = `${rect.left + window.pageXOffset - el.offsetWidth / 2 + rect.width / 2}px`;
  });


  return (
    <Portal
    >
      <ToolbarMenu
        ref={ref}
        disabled={disabled}
        className={css`
          padding: 8px 7px 6px;
          position: absolute;
          z-index: 10000;
          top: -10000px;
          left: -10000px;
          margin-top: -6px;
          opacity: 0;
          background-color: #222;
          border-radius: 4px;
          transition: opacity 0.75s;
          display: flex;
        `}
        onMouseDown={e => {
          e.preventDefault();
        }}
      >
        <MarkButton color="#fff" format="bold" icon="bold" editor={editor} />
        <MarkButton color="#fff" format="italic" icon="italic" editor={editor} />
        <MarkButton color="#fff" format="underline" icon="underline" editor={editor} />
        <MarkButton color="#fff" format="strikethrough" icon="strikethrough" editor={editor} />
        {/* <BlockButton color="#fff" format="align-left" icon="align-left" editor={editor} />
        <BlockButton color="#fff" format="align-center" icon="align-center" editor={editor} />
        <BlockButton color="#fff" format="align-right" icon="align-right" editor={editor} />
        <BlockButton color="#fff" format="align-justify" icon="align-justify" editor={editor} /> */}
      </ToolbarMenu>
    </Portal>
  );
};

export default HoveringToolbar;